import { render, staticRenderFns } from "./PDFButton.vue?vue&type=template&id=3a132f45&"
import script from "./PDFButton.vue?vue&type=script&lang=js&"
export * from "./PDFButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports